import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';

import {
    FormFieldComponentProps,
    ExtendedErrorId,
    ExtendedFieldId,
    FieldContent,
    Validator,
    OptInInputComponent,
    setCustomValidator,
    Segment,
} from '@sheerid/jslib';

import { getFaqLink } from '../../FaqLink/getFaqLink/getFaqLink';
import {
    PRIVACY_LINK,
    TERMS_AND_CONDITIONS_LINK,
} from '../../../lib/utils/constants';

const OptIn = ({
    isErrored,
    isRequired,
    onChange,
    value,
    verificationService,
}: FormFieldComponentProps) => {
    const optInFieldId: ExtendedFieldId = 'marketConsentValue';
    const segment = verificationService?.verificationResponse.segment;
    const locale = verificationService?.viewModel ? verificationService.viewModel.localeChoice.value : 'en';
    const { programId, programTheme } = verificationService;

    const getOptInValidationError: Validator = React.useCallback((value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'marketConsentRequired';
        if (isRequired && !value) {
            return invalidError;
        }
        return;
    },                                                           [isRequired]);

    React.useEffect(() => {
        setCustomValidator(optInFieldId, getOptInValidationError);
    },              [optInFieldId, getOptInValidationError]);

    return (
        <div className="sid-field sid-opt-in">
            <div className="sid-l-space-top-md" />
            <div className="sid-l-position">
                <label>
                    <OptInInputComponent
                        isErrored={isErrored}
                        onChange={onChange}
                        value={value}
                    />
                    <div className="sid-field__label sid-checkbox__label">
                        <FormattedHTMLMessage
                            id="optIn"
                            defaultMessage="The North Face® uses SheerID to verify your eligibility, as described in the <a href='{sheerIdFaq}' class='sid-link' target='_blank' rel='noopener noreferrer'>SheerID FAQs</a>. When you provide your personal information directly to SheerID using this form, SheerID will attempt to verify your eligibility, but may need to ask you for additional information or documentation. SheerID will only use your personal information to verify your eligibility. SheerID will share your personal Information with The North Face® and The North Face® may use your personal information for additional purposes, including to send you marketing communication, as described in <a href='{privacyLink}' class='sid-link' target='_blank' rel='noopener noreferrer'>The North Face® Privacy Statement</a>. By checking this box and clicking the button labelled “VERIFY MY xxx STATUS” above, you agree to the program <a href='{termsConditionsLink}' class='sid-link' target='_blank' rel='noopener noreferrer'>Terms and Conditions</a> and The North Face® Privacy Statement, and you consent to receive marketing communications from The North Face® by e-mail."
                            values={{
                                privacyLink: PRIVACY_LINK,
                                termsConditionsLink: TERMS_AND_CONDITIONS_LINK,
                                sheerIdFaq: getFaqLink(programTheme, (segment as Segment), programId, locale),
                            }}
                        />
                    </div>
                { isErrored ?
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id={'errorId.invalidOptIn'}
                            defaultMessage="Must be selected to continue"
                        />
                    </div>
                    : null
                }
                </label>
            </div>
        </div>
    );
};

export const OptInComponent  = injectIntl(OptIn);

